import {
    Directive,
    inject,
    ViewContainerRef,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { OverlayService } from './overlay.service';

@Directive({
    selector: '[telxlSharedOverlay]',
    standalone: true,
})
export class OverlayDirective implements OnInit, OnDestroy {
    viewContainerRef = inject(ViewContainerRef);
    overlayService = inject(OverlayService);

    ngOnInit() {
        this.overlayService.registerHost(this);
    }

    ngOnDestroy() {
        this.overlayService.unregisterHost();
    }
}
